export const removeAccents = (str) => {
  return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
};

export const sortAlphabetically = (items) => {
  if (!items || items.length === 0) return [];

  return [...items].sort((a, b) => {
    const nameA = removeAccents(a.name);
    const nameB = removeAccents(b.name);

    return nameA.localeCompare(nameB);
  });
};

export const groupByFirstLetter = (sortedItems) => {
  if (!sortedItems || sortedItems.length === 0) return {};

  return sortedItems.reduce((groups, item) => {
    const normalizedName = removeAccents(item.name);
    const firstChar = normalizedName.charAt(0);
    const letter = /^[A-Z]$/.test(firstChar) ? firstChar : "+";

    if (!groups[letter]) {
      groups[letter] = [];
    }
    groups[letter].push(item);

    return groups;
  }, {});
};

export const ALL_LETTERS = [
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  "+",
];
